
export default {
  name: 'App',
};
